<template>
    <div class="scroll-wrap" v-bar>
        <div class="container"  ref="scrollBar" id="scrollBar" @scroll="onScroll">
            <!--<pathBlock></pathBlock>-->
            <div class="page-index" ref="pageIndex">
                <pathAirPlane ref="svgPathEl"></pathAirPlane>
                <first id="index" class="page"></first>
                <pageMain id="main" class="page" ref="mainPage"></pageMain>
                <point1 id="point1" class="page"></point1>
                <point2 id="point2" class="page"></point2>
                <point3 id="point3" class="page"></point3>
                <point4 id="point4" class="page"></point4>
                <point5 id="point5" class="page"></point5>
                <competition id="competition"></competition>
                <last id="picnic" class="page"></last>
            </div>
        </div>
        <component :is="popup"></component>
    </div>
</template>

<script>
    import {TweenMax} from 'gsap'
    import { mapGetters } from 'vuex'
    import first from '@/components/parts/first';
    import pageMain from '@/components/parts/pageMain';
    import point1 from '@/components/pages/points/point1';
    import point2 from '@/components/pages/points/point2';
    import point3 from '@/components/pages/points/point3';
    import point4 from '@/components/pages/points/point4';
    import point5 from '@/components/pages/points/point5';
    import competition from '@/components/parts/competition';
    import last from '@/components/parts/last';

    import popup1 from '@/components/pages/popups/popup1';
    import popup2 from '@/components/pages/popups/popup2';
    import popup3 from '@/components/pages/popups/popup3';
    import popup4 from '@/components/pages/popups/popup4';
    import popup5 from '@/components/pages/popups/popup5';

    import pathAirPlane from '@/components/parts/pathAirPlane';
    import { PathMover, PathMoverTypes } from "@/components/parts/PathMover";

    export default {
        name: 'Index',
        data() {
            return {
                scrollTop:0,
                pageHeight:0,
                path: '',
                dot: '',
                firstScrolled: false,
                scroll25 : false,
                scroll50 : false,
                scroll75 : false,
                scroll100 : false
            }
        },
        components: {
            first,
            pageMain,
            point1,
            point2,
            point3,
            point4,
            point5,
            competition,
            last,
            popup1,
            popup2,
            popup3,
            popup4,
            popup5,
            pathAirPlane,

        },
        mounted(){
            if(this.$route.name=='index') {
                this.scrollToTop();
            } else {
                this.firstScrolled = true;
            }
            this.$nextTick(function () {
                this.$refs['pageIndex'].classList.add('show')
            })

            this.$refs['scrollBar'].scrollTop = document.getElementById(this.$route.name).getBoundingClientRect().top;
            this.scrollTop = document.getElementById(this.$route.name).getBoundingClientRect().top;
            this.pageHeight = document.querySelector('#scrollBar').scrollHeight;

            const SVG_PATH = this.$refs['svgPathEl'].$refs['svgPath'].$el.children[0];

            this._pathMover = new PathMover(SVG_PATH, {
                width: 62,
                height: 62,
                backwardDirectionBehavior: PathMoverTypes.BackwardDirectionBehaviorType.Calculate,
                updatePathBehavior: PathMoverTypes.UpdatePathBehaviorType.ByPercentage
            });

            this.animatedImages = document.querySelectorAll('.animate-img, .animate-block, .quotes');

            this.path = this.$refs['svgPathEl'].$el.childNodes[0].children[0];

            this.dot = this.$refs['svgPathEl'];

            //Height path
            const PathScreen = this.$refs['svgPathEl'].$el;

            let trueHeight = this.pageHeight - window.innerHeight;

            PathScreen.style.height = trueHeight + 'px';
        },
        methods: {
            scrollToTop() {
                this.$refs['scrollBar'].scrollTop = document.getElementById(this.$route.name).getBoundingClientRect().top;
            },
            checkBlock (block){
                return (block.getBoundingClientRect().top>=-window.innerHeight/2 && block.getBoundingClientRect().top<window.innerHeight/2)
            },
            getPageRoute (id) {
                return id === 'index'?'/':'/'+id;
            },
            scrollToNext(){
                TweenMax.to(this.$refs['scrollBar'],.4,{scrollTop:document.getElementById('main').getBoundingClientRect().top + this.$refs['scrollBar'].scrollTop });
            },
            onScroll (e) {
                //let block = document.querySelectorAll('.animate-img, .animate-block, .quotes');
                const LEN = this.animatedImages.length;
                for (let i=0; i<LEN; i++){
                    if (this.checkBlock(this.animatedImages [i])){
                        this.animatedImages [i].classList.add('show');
                    }
                }
                if(!this.firstScrolled){
                    if(this.$route.name==='index'){
                        this.firstScrolled = true;
                        this.scrollToNext();
                    }
                }


                const SCROLL_TOP = e.target.scrollTop;
                const SCROLL_DATA = this.getScrollData(SCROLL_TOP);
                this.updatePositions(SCROLL_DATA.percentage);
                //this.$store.commit("SET_SCROLL_PERCENTAGE", PERCENTAGE);

                let pages = document.querySelectorAll('.page');
                let currentPage = pages[0];
                for (let i=0;i<pages.length;i++){
                    if (this.checkBlock(pages[i])){
                        currentPage = pages[i];
                        this.$router.push(this.getPageRoute(currentPage.id));
                        break;
                    }
                }
                this.scrollTop = e.target.scrollTop;
                this.windowHeight = window.innerHeight;
                // start gaEvent Scroll

                let scrollPercent = Math.round( (this.scrollTop / (this.pageHeight - this.windowHeight)  ) * 100);
                if (scrollPercent >= 25 && !this.scroll25) {
                    this.$root.gaSend('main','scroll','25%');
                    this.scroll25 = true;
                }
                if (scrollPercent >= 50 && !this.scroll50) {
                    this.$root.gaSend('main','scroll','50%');
                    this.scroll50 = true;
                }
                if (scrollPercent >= 75 && !this.scroll75) {
                    this.$root.gaSend('main','scroll','75%');
                    this.scroll75 = true;
                }
                if (scrollPercent >= 90 && !this.scroll100) {
                    this.$root.gaSend('main','scroll','100%');
                    this.scroll100 = true;
                }
                // finish gaEvent Scroll
            },

            getScrollData(scrollTop) {

                if (this.$root.isMobile === false) {
                    const EL = this.$refs['svgPathEl'].$refs['svgPath'].$el;
                    const BOUNDING_BOX = EL.getBoundingClientRect();
                    const EL_HEIGHT = BOUNDING_BOX.height;
                    const WINDOW_HEIGHT = window.innerHeight;
                    const TOP = BOUNDING_BOX.y;
                    const PERCENTAGE = -(TOP / (EL_HEIGHT - WINDOW_HEIGHT));

                    return { percentage: PERCENTAGE, top: TOP };
                } else {
                    return { percentage: 0, top: 0 };
                }
            },

            updatePositions(percentage) {
                if (this.$root.isMobile === false) {
                    // const TEST_PLANE = this.$refs['testPlane'];
                    const TEST_PLANE = this.$refs['svgPathEl'].$refs['svgPath'].$el.querySelector('.ap');
                    const OBJET_POS = this._pathMover.updatePath(percentage);
                    const X = OBJET_POS.x;
                    const Y = OBJET_POS.y;
                    const ANGLE = OBJET_POS.angle;

                    TEST_PLANE.setAttribute('transform', 'translate(' + X + ', ' + Y + ') rotate(' + (ANGLE || 0) + ' ' + 32 + ' ' + 32 + ')');
                }
            },
        },
        computed: {
            popup() {
                return this.$store.getters['GET_POPUP'];
            }
        },

    }
</script>


// WEBPACK FOOTER //
// Index.vue?0b38a11c